module.exports = __webpack_public_path__ + "static/media/sushi.3245adb1.jpg";